var _g, _rect, _g2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRotateMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 162,
    viewBox: "0 0 184 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1715_48829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.5 11L101.5 11C94.6 11 89 16.6 89 23.5L89 108.5C89 115.4 94.6 121 101.5 121L141.5 121C148.4 121 154 115.4 154 108.5V23.5C154 16.6 148.4 11 141.5 11ZM121.5 116C117.35 116 114 112.65 114 108.5C114 104.35 117.35 101 121.5 101C125.65 101 129 104.35 129 108.5C129 112.65 125.65 116 121.5 116ZM144 96L99 96L99 26L144 26V96Z",
    fill: "#7B7B7B"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 66,
    width: 73,
    height: 65,
    rx: 8,
    fill: "#FBFBFB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1715_48829)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47 84.5L47 124.5C47 131.4 52.6 137 59.5 137L144.5 137C151.4 137 157 131.4 157 124.5L157 84.5C157 77.6 151.4 72 144.5 72L59.5 72C52.6 72 47 77.6 47 84.5ZM152 104.5C152 108.65 148.65 112 144.5 112C140.35 112 137 108.65 137 104.5C137 100.35 140.35 97 144.5 97C148.65 97 152 100.35 152 104.5ZM132 82L132 127L62 127L62 82L132 82Z",
    fill: "#7B7B7B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0576 34.9906C36.7232 30.7785 42.574 28.764 48.4744 28.7512L48.699 22.3101C48.7739 20.163 51.3977 19.2465 52.8589 20.865L62.0365 31.0305C62.9395 32.0307 62.886 33.5643 61.9177 34.4386L52.0758 43.3239C50.5089 44.7385 47.9435 43.4898 48.0184 41.3427L48.2453 34.8334C43.8936 34.9333 39.5952 36.4374 36.1444 39.5528C30.5809 44.5757 28.7953 52.2611 30.8737 59.1647C31.3177 60.6123 30.6506 62.1387 29.2835 62.7128C27.6558 63.4231 25.6922 62.5223 25.1392 60.7771C22.4211 51.6783 24.751 41.5871 32.0576 34.9906Z",
    fill: "#7B7B7B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1715_48829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(64 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1715_48829"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(42 162) rotate(-90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateMobile);
export default __webpack_public_path__ + "static/media/rotate-mobile.d7b21cc14ae4dd3abcac13dd22dda523.svg";
export { ForwardRef as ReactComponent };